import React from "react";
import { string } from "prop-types";
import PageMeta from "../PageMeta";

const ImageLink = ({ href }) => (
	<PageMeta.Custom>
		{/* eslint-disable-next-line react/no-unknown-property */}
		<link rel="preload" as="image" href={href} fetchPriority="high" />
	</PageMeta.Custom>
);

ImageLink.propTypes = {
	href: string,
};

export default ImageLink;
